import { Observable } from "./observable";

function loadFromLocalStorage(key: string) {
  const val = window.localStorage.getItem(key);
  if (val == null) {
    return null;
  }
  return JSON.parse(val);
}

export class LocalStoragePersistedObservable<T extends any> extends Observable<T> {

  constructor(private readonly key: string, initVal: T) {
    super(loadFromLocalStorage(key) || initVal);
  }

  set(val: T) {
    super.set(val);
    window.localStorage.setItem(this.key, JSON.stringify(val));
  }

  delete() {
    window.localStorage.removeItem(this.key);
  }
}
